const se = {
  meta: { title: "Trollfossjakten · The Troll Waterfall Quest — 84 stálu Lavangena ja Årsteina gaskkas" },
  sound: { mute: "Jaskkut stálu jienaid", unmute: "Čuojat stálu jienaid" },
  nav: { map: "Kárta", trolls: "Stálut", seasons: "Jahkeáiggit", pricing: "Hattit", faq: "Gažaldagat", getApp: "Viečča appa", hosts: "Šatta guossoheaddjin" },
  tagline: "61 stállu nuvttá agibeaivái. Earát čiehkádit — váldde pássa fárrui.",
  store: { soon: "Appa lea measta boahtimin vuovddis", soonBody: "Gávpeliŋkkat rahppojit go appa almmuhuvvo — geahča fas fargga.", appStore: "App Store", playStore: "Google Play", download: "Viečča", getIt: "Viečča" },
  hero: {
    kicker: "Loabát · Rivttát · Romsa",
    title: "Bivdde 84 stálu Lavangena ja Årsteina gaskkas.",
    pitch: "9 goržži, 84 gieđain ráhkaduvvon stálu ja okta vuotnageaidnu. Nuvttá álgit — dálvet sabehiiguin ja geassit rulleskeittaiguin.",
    cta: "Álgge bivddu",
    ctaMap: "Geahča olles kártta",
    stats: [["84", "stálut"], ["9", "goržžit"], ["61", "nuvttá agibeaivái"], ["4", "jahkeáiggit"]],
    stamp: "Nuvttá álgit",
    photoNote: "Goržžit · vuonat · stálut",
  },
  what: {
    kicker: "Mii lea Trollfossjakten?",
    title: "Máidnasiid dávvirbivdu duođalaš vuotnageainnu guora.",
    cols: [
      { title: "Vácce bálgá", body: "Čuovo geainnu Lavangenis Årsteinii vázzit, sihkkeliin, sabehiiguin dahje rulleskeittaiguin. Ovcci goržži čájehit geainnu." },
      { title: "Dohppe stáluid", body: "84 gieđain ráhkaduvvon stálu čiehkádit johkagáttiin, mearragáttis ja gávppiin. Gávnna daid, dohppe daid ja deavdde beaivegirjji." },
      { title: "Diena Trollkruvnnuid", body: "Čoakkit appa ruđa ja geavat dan ovttasbargoguoimmiid hyttain, kaféain ja gávppiin bálgá guora." },
    ],
    callout: "Ii dárbbaš registreret. Raba appa ja álgge bivddu.",
  },
  map: {
    kicker: "Bálgákárta",
    title: "Juohke stállu kárttas.",
    body: "84 stálu leat geainnu guora Lavangenis Årsteinii, Røkenesa, Hestnesa ja Sørsida bokte. Coahkkal merkii deaivvadit stálloin — dasto dohppe dan duođas appas.",
    chips: { all: "Buot", common: "Dábálaš", rare: "Hárvenaš", epic: "Epihkalaš", legendary: "Legendáralaš", festivals: "Festiválat", merchants: "Gávpealbmát" },
    showing: "stálu čájehuvvojit",
    start: "Lavangen · álgu",
    finish: "Årstein · loahppa",
    waterfall: "Gorži",
    catchIt: "Dohppe dan appas",
    close: "Gidde",
    recenter: "Guovddáštahte",
  },
  xp: {
    kicker: "XP ja speallovuogádat",
    title: "Bivdde, loktte dási, rámpot veahá.",
    body: "Juohke dohppen addá XP. Hárvenaš stálut addet eambbo — ja muhtimat bohtet oidnosii dušše go kaleandar nu dadjá.",
    cards: {
      xp: { title: "XP hárvenašvuođa mielde", body: "Mađi buorebut čiehkádit, dađi eambbo addet." },
      ach: { title: "12 olahusa", body: "Gitta 5 000 XP juohkehažžii. Muhtimat álggahussan:", more: "+ 6 eará maid gávnnat appas" },
      items: { title: "Dávvirat ja čoakkáldagat", body: "Čoakkit uhca dávviriid maid stálut guđđet, ja dievasmahte čoakkáldagaid.", list: ["Perlat", "Runat", "Vafflat", "Mearrarievvára golli"] },
      kroner: { title: "Trollkruvnnut", body: "Dinejuvvojit go bovdet ustibiid, beaivválaš jorahusas ja gávpealbmástáluin. Geavahuvvojit ovttasbargoguoimmiid hyttain ja gávppiin." },
    },
    achievements: [["Vuosttaš dohppen", 20], ["Festiválaustit", 500], ["Johkagonagas", 800], ["Okto soahteolmmái", 1000], ["Legendáralaš bivdi", 1500], ["Jahkeáiggiid jorbbas", 5000]],
    extras: [
      { title: "Ráiddut + Ráidosuodji", body: "Bivdde juohke beaivvi vai ráidu šaddá. Suodji gádju ovtta vajálduvvon beaivvi juohke vahkus." },
      { title: "Beaivválaš jorahus", body: "Deattuhuvvon rulett golmmain dásiin. Okta jorahus juohke 24 diimmu." },
      { title: "Pássat", body: "Epihkalaš pássa dahje Hárvenaš pássa gustojit 365 beaivvi aktiverema rájes. Olmmoš-, bearaš-, joavku- ja bussejoavkodásit." },
      { title: "Erenoamáš stálut", body: "2 vahkkoloahppastálu (bearjadat–sotnabeaivi), 10 festiválastálu, 6 gávpealbmástálu báikkálaš fitnodagain ja 5 kampánjastálu." },
    ],
  },
  gallery: {
    kicker: "Stállobeaivegirji",
    title: "Deaivva buot 84.",
    body: "Juohke stállus lea namma, lasánamma ja vierru. Coahkkal kortii ja loga su beaivegirjji.",
    chips: { all: "Buot", common: "Dábálaš", rare: "Hárvenaš", epic: "Epihkalaš", legendary: "Legendáralaš", festivals: "Festiválat", merchants: "Gávpealbmát", weekend: "Vahkkoloahppa", promo: "Kampánja" },
    more: "Čájet eambbo stáluid",
    count: "/ 84",
    portraitNote: "Earát čiehkádit — gávnna daid appas.",
    hidden: "čiehkáda ain",
    hiding: "Čiehkáda",
  },
  journal: {
    entry: "Beaivegirjječálus",
    where: "Gos",
    waterfall: "Gorži",
    xp: "XP",
    access: "Rahpan",
    window: "Oidno",
    weekend: "Dušše bearjadagas sotnabeaivái",
    liveNow: "Olgun dál",
    catchIt: "Dohppe dan appas",
  },
  access: { free: "Nuvttá agibeaivái", epic_pass: "Epihkalaš pássa", rare_pass: "Hárvenaš pássa" },
  rarity: { common: "Dábálaš", rare: "Hárvenaš", epic: "Epihkalaš", legendary: "Legendáralaš" },
  category: { stream: "Johkastállu", intro: "Álggahanoahpaheaddji", merchant: "Gávpealbmástállu", promo: "Kampánjastállu", weekend: "Vahkkoloahppastállu", festival_sami: "Sámi festiválastállu", festival_norwegian: "Norgga festiválastállu" },
  specials: {
    kicker: "Erenoamáš stálut",
    title: "19 erenoamáš stálu — ja 5 kampánjastálu lassin.",
    body: "Muhtin stálut čuvvot iežaset kaleandara. Festiválastálut bohtet oidnosii dušše duođalaš festiválabeivviid.",
    flavours: [
      { key: "intro", count: 1, title: "Álggahanoahpaheaddji", body: "Du vuosttaš stállu Lavangenis — čájeha movt bivdu doaibmá." },
      { key: "festival_sami", count: 4, title: "Sámi festiválastálut", body: "Sámi álbmotbeaivi, Riddu Riđđu ja Márkomeannu." },
      { key: "festival_norwegian", count: 6, title: "Norgga festiválastálut", body: "Miessemánu 17. beaivvis gitta skábmii." },
      { key: "weekend", count: 2, title: "Vahkkoloahppastálut", body: "Olgun dušše bearjadagas sotnabeaivái." },
      { key: "merchant", count: 6, title: "Gávpealbmástálut", body: "Orrot duođalaš báikkálaš fitnodagain bálgá guora." },
      { key: "promo", count: 5, title: "Kampánjastálut", body: "Rahpasit go bovdet ustibiid, plakáhtaiguin ja kampánjakodaiguin." },
    ],
    calendar: "Festiválakaleandar",
    next: "Boahtte áigi",
    liveNow: "Olgun dál",
  },
  festivals: {
    "Sámi National Day": "Sámi álbmotbeaivi", "Riddu Riđđu": "Riddu Riđđu", "Márkomeannu": "Márkomeannu",
    "Constitution Day": "Vuođđolágabeaivi", "Midsummer": "Gaskageassi", "Lussinatta": "Lussi-idja",
    "Christmas": "Juovllat", "Midnight Sun": "Gaskaijabeaivváš", "Polar Night": "Skábma",
  },
  seasons: {
    kicker: "Njeallje jahkeáiggi",
    title: "Okta bálggis, njeallje hui sierralágan dovdamuša.",
    standout: "Erenoamáš stállu",
    tabs: {
      winter: { name: "Dálvi", title: "Sabehat guovssahasa vuolde", body: "Čuoiggat bálgá guora go guovssahasat dánsot vuona badjel. Oaivečuovga oaivái, termosa dievva." },
      spring: { name: "Giđđa", title: "Boazobeassážat", body: "Guhkes, čuovga beaivvit, čearga muohta ja bohccot johtimin. Heive bearrašiidda dássidis osiin." },
      summer: { name: "Geassi", title: "Gaskaijabeaivváš-dolat", body: "Rulleskeitte šuvges osiin, divtte mánáid sihkkelastit ovddabealde, ja cahkkes dola go beaivváš ii hálit luoitádit." },
      autumn: { name: "Čakča", title: "Guobbarvánddardeamit", body: "Gollerivnnat soagit, sarrit ja guobbarat. Áhkut ja áddját liikojit dássidis osiide — nu maid stálut." },
    },
  },
  merchants: {
    kicker: "Báikkálaš fitnodagat",
    title: "Gávpealbmástálut orrot duođalaš báikkálaš sajiin.",
    body: "Guhtta stálu orrot hyttain, kaféain, gávppiin ja láigohanbáikkiin bálgá guora. Gávnna daid nuvttá ja geavat Trollkruvnnuid doppe.",
    partnerSoon: "Ovttasbargoguoibmi almmuhuvvo álggahettiin",
    spend: "Geavat Trollkruvnnuid dáppe",
    types: { "Cabin rental": "Hyttaláigoheapmi", "Farm shop": "Dállogávpi", "Café": "Kafea", "Kayak rental": "Kajákkaláigoheapmi", "Bakery": "Láibbádus", "Grocer · finish line": "Gávpi · loahppa" },
  },
  pricing: {
    kicker: "Hattit",
    title: "Álgge nuvttá. Váldde pássa fárrui earáide.",
    launch: "Álggahanhaddi · 50 % vuolideapmi 2026 jahkeáiggis",
    tiers: { person: "Olmmoš", family: "Bearaš", team: "Joavku", bus: "Bussejoavku" },
    days: "365 beaivvi aktiverema rájes",
    free: { name: "Nuvttá", price: "0 kr", line: "61 stállu nuvttá agibeaivái", body: "Ii dárbbaš registreret.", perks: ["Buot dábálaš ja hárvenaš johkastálut", "Buot 6 gávpealbmástálu", "Álggahanoahpaheaddji + 5 kampánjastálu"], cta: "Álgge nuvttá" },
    epic: { name: "Epihkalaš pássa", line: "Rahpá epihkalaš + legendáralaš stáluid", perks: ["Buot epihkalaš ja legendáralaš johkastálut", "Goappašat vahkkoloahppastálut"], cta: "Viečča Epihkalaš pássa" },
    rare: { name: "Hárvenaš pássa", line: "Rahpá buot stáluid — maiddái festivála- ja legendáralaš stáluid", perks: ["Buot 84 stálu", "Buot 10 festiválastálu", "Buot mii lea Epihkalaš pássas"], cta: "Viečča Hárvenaš pássa", ribbon: "Buot 84 stálu" },
    note: "Pássat oastojuvvojit appas. Álggahanhaddi lea áigeráddjejuvvon.",
    was: "ovdal",
  },
  faq: {
    kicker: "Gažaldagat",
    title: "Gažaldagat bálgá álggus.",
    items: [
      ["Fertengo registreret?", "It. Viečča appa, raba dan ja álgge bivdit. 61 stállu leat nuvttá agibeaivái."],
      ["Leago mobiilasignála bálgá guora?", "Geainnu guora lea dábálaččat buorre signála, muhto muhtin leahkebáikkiin sáhttá leat heajut. Ladde telefovnna ja čále heahtenummiriid ovdal go vuolggát."],
      ["Sáhtángo geavahit dan dálvet?", "Sáhtát. Stálut leat olgun olles jagi. Váldde fárrui sabehiid dahje gabbaid, oaivečuovgga skábmii, ja dárkkis geaidnodili ovdal go vuolggát."],
      ["Heivešgo dat mánáide?", "Heive. Ollu stálut leat lahka geainnu, ja dássidis osiin heivejit uhca julggiide, sihkkeliidda ja mánávovnnaide. Oassi bálgás čuovvu almmolaš geainnu, nu ahte fuomáš johtolaga."],
      ["Gos sáhtán parkeret, ja movt boađán ruoktot?", "Álgge Lavangenis dahje Årsteinis. Guovllubussat johtet muhtin osiin — dárkkis báikkálaš áigetabealla ovdal go vuolggát."],
      ["Mii lea gávpealbmástállu?", "Stállu mii orru duođalaš báikkálaš fitnodagas bálgá guora — hyttas, kaféas dahje gávppis. Dan sáhtát dohppet nuvttá, ja doppe sáhtát geavahit Trollkruvnnuid."],
      ["Mat leat Trollkruvnnut?", "Appa ruhta. Dan dinet go bovdet ustibiid, beaivválaš jorahusas ja gávpealbmástáluin, ja geavahat dan ovttasbargoguoimmiid hyttain ja gávppiin."],
      ["Man dárkilat leat festiválabeaivvit?", "Festiválastálut bohtet oidnosii dušše duođalaš festiválabeivviid siskkobealde. Jus festivála sirdá beivviid, de sirdása maiddái stállu."],
      ["Man guhká pássa gusto?", "Epihkalaš ja Hárvenaš pássa gustojit 365 beaivvi dan beaivvi rájes go aktiveret daid. Leat olmmoš-, bearaš-, joavku- ja bussejoavkodásit."],
      ["Mo lea mu persovdnasuodjalusain?", "Sáhtát speallat almmá kontu haga. Appa geavaha du sajádaga čájehit lagaš stáluid go speallat. Dát neahttasiidu ii jeara maidege."],
    ],
  },
  install: { title: "Trollfossjakten", body: "61 stállu nuvttá agibeaivái", cta: "Viečča appa", dismiss: "Gidde sajáiduhttinsárggá" },
  footer: { supporter: "Šatta doarjjaguoibmin", about: "Min birra", press: "Preassa", privacy: "Persovdnasuodjalus", terms: "Eavttut", contact: "Oktavuohta", follow: "Čuovo bivddu", soon: "Boahtá álggahettiin", country: "Norga", supportedBy: "Doarjjaguoimmit" },
  logoAlt: "Trollfossjakten logo",
  langSwitch: "Giella",
  a11y: { menu: "Fállu", footer: "Vuolleoassi", zoomIn: "Stuorit", zoomOut: "Unnit", notifications: "Dieđáhusat" },
  sos: "Heahtedieđut",
  emergency: {
    back: "Ruovttoluotta",
    title: "Heahtedilli",
    alert: "Jus leat vára vuolde, riŋge báikkálaš heahtenummirii dakkaviđe.",
    h1: "SOS — jođánis veahkki, gos fal bálgá guora.",
    intro: "Coahkkal nummirii riŋgen dihtii. Juoge du dálá sajádaga, válljet govain ja dieđuin, bearrašiin, ustibiiguin dahje gádjunbálvalusain.",
    step: "{n}. lávki",
    country: "Du riika",
    search: "Oza riika…",
    noMatch: "Ii gávdnon riika",
    callNow: "Riŋge dál —",
    all: "Buot heahtedilit",
    police: "Politiija",
    fire: "Buollinsuodjalus",
    ambulance: "Ambulánsa",
    locTitle: "Sádde du dálá sajádaga",
    detect: "Gávnna mu sajádaga",
    locating: "Ohcamin sajádaga…",
    refresh: "Ođasmahte sajádaga",
    noGeo: "Du neahttalohkki ii doarjjo sajádaga.",
    locFail: "Ii lihkostuvvan gávdnat du sajádaga.",
    near: "Lahka",
    openMaps: "Raba Google Maps:as ↗",
    msgLabel: "Lasit dieđu (válljet)",
    msgPh: "Omd. Bonjen julggi nuppi goržži lahka. Váldde fárrui čázi ja vuosttašveahkkeskáhpu.",
    photoLabel: "Lasit gova (válljet)",
    choose: "Vállje gova",
    change: "Rievdat gova",
    remove: "Sihko",
    previewAlt: "Laktojuvvon govva",
    send: "Sádde heahtesajádaga",
    copy: "Máŋge",
    shared: "Juogaduvvon du rusttegis.",
    shareFail: "Ii sáhttán rahpat juogadanfálu. Geahččal baicce Máŋge.",
    copied: "Máŋgejuvvon.",
    copyFail: "Máŋgen ii lihkostuvvan.",
    privacy: "Juogadeapmi geavaha du telefovnna iežas juogadanfálu (SMS, WhatsApp, e-poasta jna.). Mihkkege ii sáddejuvvo min bálvaid bokte. Duođalaš heahtedilis riŋge álo maiddái nummirii bajábealde.",
    backTrail: "Ruovttoluotta bálgái",
    msgHead: "🆘 HEAHTEDILLI — Dárbbašan veahki.",
    mapLabel: "Kárta",
    timeLabel: "Áigi",
    shareTitle: "Heahtedilli — Trollfossjakten",
    countries: {
      NO: "Norga", SE: "Ruoŧŧa", FI: "Suopma", DK: "Dánmárku", IS: "Islánda", DE: "Duiska", FR: "Frankriika",
      GB: "Stuora-Británnia", IE: "Irlánda", NL: "Hollánda", ES: "Spánia", IT: "Itália", PL: "Polen",
      US: "Amerihká ovttastuvvan stáhtat", CA: "Kanáda", AU: "Austrália", NZ: "Ođđa-Selánda", CN: "Kiinná", RU: "Ruošša", TH: "Thaieana",
    },
    notes: {
      NO: "112 lea Eurohpá heahtenummir. 110 olaha buollinsuodjalusa ja 113 njuolgga medisiinnalaš veahki.",
      SE: "Okta heahtenummir, 112, buot bálvalusaide.",
      FI: "112 olaha politiija, buollinsuodjalusa ja ambulánssa.",
      DK: "112 heahtediliide, 114 politiijai go ii leat hoahppu.",
      IS: "Okta nummir olles riikkas: 112.",
      DE: "110 politiijai, 112 buollinsuodjalussii ja ambulánsii.",
      FR: "17 politiija, 18 buollinsuodjalus, 15 ambulánsa (SAMU). 112 maid doaibmá.",
      GB: "999 (dahje 112) buot heahtediliide. 101 politiijai go ii leat hoahppu.",
      IE: "Sihke 112 ja 999 doibmet.",
      NL: "112 heahtediliide, 0900-8844 politiijai go ii leat hoahppu.",
      ES: "112 gokčá buot. Riikapolitiija 091, báikkálaš politiija 092.",
      IT: "112 buot heahtediliide, 113 stáhtapolitiija.",
      PL: "112 olaha buot bálvalusaid.",
      US: "Riŋge 911 buot heahtediliin. 311 go ii leat heahtedilli, ollu gávpogiin.",
      CA: "911 olles riikkas buot heahtediliide.",
      AU: "Triple Zero (000). 112 maid doaibmá mobiilatelefovnnain.",
      NZ: "111 olles riikkas. 105 politiijai go ii leat hoahppu.",
      CN: "110 politiija, 119 buollinsuodjalus, 120 ambulánsa. 122 johtolatlihkuhisvuođaide.",
      RU: "112 olaha buot bálvalusaid. 102 politiija, 101 buollinsuodjalus, 103 ambulánsa.",
      TH: "191 politiija, 199 buollinsuodjalus, 1669 ambulánsa. Turistapolitiija 1155 (hállet eaŋgalsgiela).",
    },
  },
};

export default se;
